import { CategoryTreeObject } from "@vviinn/user-managment-client-ts";

export const traverseCategoryTree = (
  predicate: (t: CategoryTreeObject) => boolean,
  tree: CategoryTreeObject,
  path: CategoryTreeObject[] = [],
): [CategoryTreeObject, CategoryTreeObject[]] | undefined => {
  const leafs = tree.tree ?? [];
  if (predicate(tree)) {
    return [tree, [...path, tree]];
  } else {
    for (const leaf of leafs) {
      const result = traverseCategoryTree(predicate, leaf, [...path, tree]);
      if (result) {
        return result;
      }
    }
    return undefined;
  }
};
